import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing.lg} ${theme.spacing.xl};
  gap: ${theme.spacing['2xl']};
  border-radius: ${theme.borderRadius.md};
  background-color: ${theme.semantic.surface.sunken};
`;
export const Copy = styled.div `
  flex-direction: column;
  display: flex;
`;
export const SwitchContainer = styled.div `
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: ${theme.spacing.md};
`;
export const Row = styled.div `
  display: flex;
  align-items: center;
  gap: ${theme.spacing['2xl']};
`;
